import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PointStoreUtilityService {

  pointStoreUtility: any = {
    data: {
      upgLoad: 0,
      isButtonDisabled: false
    },
  };

  constructor() { }

  setUpgLoad(bool) {
    if (bool) {
      if (this.pointStoreUtility.data.upgLoad == 0) {
        $("#upgLoad").show();
      }
      this.pointStoreUtility.data.upgLoad += 1;
      this.pointStoreUtility.data.isButtonDisabled = true;
    } else {
      this.pointStoreUtility.data.upgLoad -= 1;
    }

    if (this.pointStoreUtility.data.upgLoad <= 0) {
      $("#upgLoad").hide();
      this.pointStoreUtility.data.upgLoad = 0;
      this.pointStoreUtility.data.isButtonDisabled = false;
    }
  }
}
